//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BenefitsCardItem from './BenefitsCardItem';
import benefitsImageOne from '~/assets/images/benefit-01-cropped.jpg';
import benefitsImageTwo from '~/assets/images/benefit-02-cropped.jpg';
import benefitsImageThree from '~/assets/images/benefit-03-cropped.jpg';
export default {
  name: 'Benefits',
  components: {
    BenefitsCardItem
  },

  data() {
    return {
      benefitsItems: [{
        id: 'benefitsItem-1',
        number: '01',
        image: benefitsImageOne,
        text: 'EASIER APPROVAL ON AN APARTMENT'
      }, {
        id: 'benefitsItem-2',
        number: '02',
        image: benefitsImageTwo,
        text: 'LOWER CAR PAYMENTS'
      }, {
        id: 'benefitsItem-3',
        number: '03',
        image: benefitsImageThree,
        text: 'A BETTER MORTGAGE ON YOUR DREAM HOME'
      }]
    };
  }

};